import React, { Fragment } from 'react';
import IconButton from '@material-ui/core/IconButton';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import Tooltip from '@material-ui/core/Tooltip';

const ItemsListActions = ({ data, removeItem }) => {

    
    const removeItemFromInvoice = () => {
        
        console.log("dataItem",data);
        if (typeof removeItem != 'undefined') {
            removeItem(data.data.index,data.data.original);
        }
        
    }

    return (<Fragment>
        <td role="cell">
            <Tooltip title="Eliminar Item">
                <IconButton style={{ fontSize: '15px' }} onClick={() => removeItemFromInvoice()}>
                    <FontAwesomeIcon icon={faTrashAlt} />
                </IconButton>
            </Tooltip>
        </td>

    </Fragment>)
}

export default ItemsListActions;